export default __webpack_public_path__ + "static/media/04.459e2581.jpg";